var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTobaccoSale = function SvgTobaccoSale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#454D54",
    d: "M29 32H2V0h27v32ZM5.176 21.823V28.8h20.648v-6.273L14.705 17.6l-9.53 4.223ZM22.647 27.2H8.353v-1.6h14.294v1.6ZM5.177 8h20.646V6.4H5.177V8Z"
  })));
};
export default SvgTobaccoSale;